<template>
  <div class="col-md-3 grid-item">
    <article class="card mx-md-15 mb-30">
      <router-link class="img-link img-holder text-decoration-none font-weight-semibold" :to="{ name: 'ResourcePage', params: { urlsegment: item.URLSegment }}">
        <picture>
          <img :src="item.ImageThumb" alt="image description" class="img-fluid card-img-top w-100" />
        </picture>
      </router-link>
      <div class="card-body">
        <router-link class="card-title text-decoration-none font-weight-semibold mb-15 js-card-title" :to="{ name: 'ResourcePage', params: { urlsegment: item.URLSegment }}">{{item.Name}}</router-link>
        <!-- <a
          :href="item.URL"
          class="card-title text-decoration-none font-weight-semibold mb-15"
        >{{ item.Name }}</a> -->
        <span class="tag text-uppercase font-weight-medium">
          <a
            style="margin-right: 5px;"
            v-for="type in item.Types"
            :href="link(type.name)"
          >{{ type.name }}</a>
        </span>
      </div>
    </article>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  props: ["item"],
  computed: {
    ...mapState([
      "search_link",
    ]),
  },

  methods: {
    link(term) {
      return `${this.search_link}?types[]=${term}`
    }
  }
}
</script>
